import React from 'react';
import {View} from 'react-native';
import {buttonsStyles} from '../../../Button/boutonStyle';
import PrimaryButton from '../../../Button/PrimaryButton';
import {Container} from '../../../Container';
import styles from './styles';
interface Props {
  active?: string;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  callBack: Function;
}
export default function AgeTab({active, callBack}: Props) {
  return (
    <Container>
      <View style={styles.formContainer}>
        <View style={buttonsStyles.btnTabWrapper}>
          <PrimaryButton
            onPress={() => callBack('-12')}
            styleBtnTxt={[
              buttonsStyles.btnTabTxt,
              active === '-12' && buttonsStyles.btnTabTxtActive,
            ]}
            styleBtnOuter={[
              buttonsStyles.btnTabOuter,
              active === '-12' && buttonsStyles.btnTabOuterActive,
            ]}
            title="- 12 ans"
          />
          <PrimaryButton
            onPress={() => callBack('12')}
            styleBtnTxt={[
              buttonsStyles.btnTabTxt,
              active === '12' && buttonsStyles.btnTabTxtActive,
            ]}
            styleBtnOuter={[
              buttonsStyles.btnTabOuter,
              active === '12' && buttonsStyles.btnTabOuterActive,
            ]}
            title="+ 12 ans"
          />
        </View>
      </View>
    </Container>
  );
}
